module.exports = __webpack_public_path__ + "static/media/sending_waves@2x.df3570d0.png";